import React from 'react';
import { scrollToElement } from '../../lib/userFunctions';
import { SchoolRecommendLatest } from './school/SchoolRecommendLatest';
import { ThemeRecommend }  from './ThemeRecommend';
import UserRecommend from './UserRecommend';

export const RecommendPage = ()=>{

    return (
        <div className="subpage recommendSubpage">
            <div className="visualHeader">
                <div className="inner">
                    <h1 className="mainTitle">추천 도서</h1>
                    <p className="guide">
                        어떤 책을 읽으면 좋을까? <br/>
                        친구들에게 좋은 책을 추천합니다!
                    </p>
                    <div className="bookgomi"></div>
                </div>
            </div>
            <div id="contents" className="recommend recommendPage">
                <div className="scrollBtn">
                    <ul>
                    <li className="clear"><button className="ThemeRecommendBtn" onClick={()=>scrollToElement('themeRecommend')}>주제추천</button></li>
                        <li className="clear"><button className="userRecommendBtn" onClick={()=>scrollToElement('userRecommend')}>맞춤추천</button></li>
                        <li className="clear"><button className="schoolRecommendBtn" onClick={()=>scrollToElement('schoolRecommend')}>학교추천</button></li>
                    </ul> 
                </div>
                <div className="inner">
                    <ThemeRecommend />
                    <UserRecommend />
                    <SchoolRecommendLatest />
                </div>
            </div>
            <div className="visualFooter">
                <div className="bg"></div>
                <div className="box"></div>
            </div>
        </div>
    );
}